import React from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, InputField, Masks } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";

function Form({ data, mode, ...rest }) {
    const readonly = mode === "view";

    const phoneNumberValidator = Yup.string().test("Valid home phone", "Incorrect format. Example 123-456-7890", (value) =>
        value ? /^\d\d\d-\d\d\d-\d\d\d\d/.test(value) : true
    );

    const validationSchema = Yup.object({
        name: Yup.string().required("Required field"),
        address: Yup.string().required("Required field"),
        email: Yup.string().notRequired().email("Incorrect email"),
        phoneNumber: phoneNumberValidator,
        fax: phoneNumberValidator,
    });

    return (
        <FormikForm initialValues={data} validationSchema={validationSchema} {...rest} showButtons={mode === "add"}>
            <div className="layout">
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <FormControl component="fieldset">
                            <FormGroup row>
                                <InputField disabled={readonly} fieldName="name" label="Name *" />
                                <InputField disabled={readonly} fieldName="address" label="Address *" />
                                <InputField
                                    disabled={readonly}
                                    fieldName="email"
                                    label="Email"
                                    helperText="e.g myname@domain.com"
                                    lowercase
                                    light
                                    compact
                                />
                                <InputField
                                    disabled={readonly}
                                    fieldName="phoneNumber"
                                    label="Phone Number"
                                    mask={Masks.phoneNumber}
                                    light
                                    compact
                                />
                                <InputField disabled={readonly} fieldName="fax" label="Fax" mask={Masks.phoneNumber} light compact />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </FormikForm>
    );
}

Form.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        address: PropTypes.string,
    }),
    mode: PropTypes.oneOf(["add", "view"]).isRequired,
};

Form.defaultProps = {
    data: {
        id: 0,
        name: "",
        address: "",
    },
    mode: "view",
};

export default Form;
